import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const  GstDetails = () =>{
  return(
   <DocumentDetails documentType={'gst-certificates'} keyAccess={'HawkAI-GSTCert'} title={'GST Certificate'} exportDataToExcelName={'Gst Document'} analysefrom={'gst-certificate'} deleteText={'gst-certificate'} modelName={'doc-ai'} webSocketName={'gst'}/>
  )
 };
 export default GstDetails;